<template>
    <el-form label-width="120px" class="demo-userInfo" accept-charset="UTF-8">
        <el-form-item label="用户名" prop="name">
            <el-input
                v-model="userInfo.name"
                :readonly="registrations.nameUserIdCard ? 'readonly' : true"
                id="input1"
                width="200"
            ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
            <el-input
                v-model="userInfo.idcard"
                @input="getIdcard()"
                id="input2"
                :readonly="registrations.forbidEditIdCard ? 'readonly' : true"
            ></el-input>
        </el-form-item>
        <el-form-item prop="orgId" label="组织" :rules="rules.orgId">
                <el-cascader
                    expand-trigger="hover"
                    v-model="userInfo.orgId"
                    :options="options"
                    :props="list"
                    :disabled="disabledOrg"
                    :show-all-levels="false"
                ></el-cascader>
            </el-form-item>
        <el-form-item prop="customOrgId" label="工种" :rules="rules.customOrgId">
            <el-select v-model="userInfo.customOrgId" :show-all-levels="false">
                <el-option
                    v-for="o in registrations.occupations"
                    :key="o.id"
                    :label="o.name"
                    :value="o.id"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item
            v-for="item in items"
            :label="item.lablename"
            :prop="item.regname"
            :key="item.regname"
        >
            <el-input v-if="item.optionType == 'text'" v-model="userInfo[item.regname]"></el-input>
            <el-date-picker
                v-if="item.optionType == 'date'"
                v-model="userInfo[item.regname]"
                type="date"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-select
                v-if="isSelected(item.optionType)"
                v-model="userInfo[item.regname]"
                :show-all-levels="false"
            >
                <el-option
                    v-for="o in item.optionData"
                    :key="o.value"
                    :label="o.text"
                    :value="o.value"
                ></el-option>
            </el-select>
            <el-upload
                v-if="item.optionType === 'img'"
                class="avatar-uploader"
                :action="UploadUrl()"
                :headers="{Authorization: token}"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
            >
                <pic v-if="!!fileUrl(item.regname)" :src="fileUrl(item.regname)" class="avatar" />
                <i v-if="!fileUrl(item.regname)" class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </el-form-item>
        <el-form-item style="margin-top:50px;">
            <el-button type="primary" @click="submitForm()">确认修改</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    props: ['close'],
    data() {
        return {
            props: ['close'],
            registrations: this.$getRegistrationItem(),
            userInfo: JSON.parse(JSON.stringify(this.$store.state.user)),
            oldData: JSON.parse(JSON.stringify(this.$store.state.user)),
            modifyData: {},
            addInfo: {},
            options: [],
            orgid:'',
            list: {
                value: 'id',
                label: 'name'    
            },
            disabledOrg:''
        }
    },
    watch: {
        userInfo: {
            handler(newValue) {
                for (let k in newValue) {
                    if (typeof newValue[k] === 'object') {
                        continue
                    }
                    if (newValue[k] !== this.oldData[k]) {
                        this.modifyData[k] = newValue[k]
                    } else {
                        delete this.modifyData[k]
                    }
                }
            },
            immediate: false,
            deep: true
        }
    },
    created() {
        this.getReitem()
        this.option()
    },
    computed: {
        items() {
            return this.registrations.registrationItem
        },
        token() {
            return this.$store.state.Authorization
        }
    },
    methods: {
        option(){
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/org/getArea', {
                    params: { platformId }
                })
                .then(res => {
                    let list = res.data.data
                    function getOption() {
                        let pidStr = 'parentId'
                        let idStr = 'id'
                        let childrenStr = 'children'
                        let listObj = {}
                        let treeList = []
                        for (let i = 0; i < list.length; i++) {
                            listObj[list[i][idStr]] = list[i]
                        }
                        for (let j = 0; j < list.length; j++) {
                            let haveParent = listObj[list[j][pidStr]]
                            if (haveParent) {
                                !haveParent[childrenStr] &&
                                    (haveParent[childrenStr] = [])
                                haveParent[childrenStr].push(list[j])
                            } else {
                                treeList.push(list[j])
                            }
                        }
                        return treeList
                    }
                    var a = getOption()
                    this.options = a
                    if(this.addInfo.forbidEditOrg){
                        this.orgid = this.options[0].id
                        this.userInfo.orgId = [this.orgid]
                    }
                })
                .catch(res => {
                    console.log('err')
                })
        },
        getReitem() {
            let addInfo = JSON.parse(localStorage.getItem('registrationItems'))
            this.addInfo = addInfo
            if(addInfo.forbidEditOrg){
                this.disabledOrg = true
            }else{
                this.disabledOrg = false
            }
        },
        UploadUrl: function() {
            return this.$managePath + '/offline/api/user/uploadAvatar'
        },
        isSelected(optionType) {
            return optionType == 'radio' || optionType == 'select'
        },
        beforeAvatarUpload(file) {
            const me = this
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            if (!(isJPG || isPNG)) {
                me.$message.error('上传的文件只能是 JPG 或者是 PNG 格式的')
            }
        },
        handleAvatarSuccess(data) {
            this.userInfo.picture = data.data
            this.$store.commit('changeLogin', {
                Authorization: this.$store.state.Authorization
            })
        },
        submitForm() {
            let data = this.modifyData
            if (JSON.stringify(data) === '{}') {
                return successCallback(this)
            }
            data.id = this.userInfo.id
            let org_id = this.userInfo.orgId
            let custom_org_id = this.userInfo.customOrgId
            let platform_id = localStorage.getItem('datas')
            let user_json = JSON.stringify(data)
            let dats={
                org_id:org_id,
                custom_org_id : custom_org_id,
                platform_id : platform_id,
                user_json:user_json
            }
            let qs = require('qs')
            this.$axios
                .post(
                    this.$managePath + '/yunapi/user_api/update_user_info',
                    qs.stringify(dats),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;'
                        }
                    }
                )
                .then(res => {
                    if (res.data.status == 0) {
                        this.$store.commit('changeLogin', {
                            Authorization: this.$store.state.Authorization
                        })
                        successCallback(this)
                    }
                })
                .catch(res => {
                    console.log('addOrEditUser err')
                })
            function successCallback(_this) {
                _this.$emit('close')
                _this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: function() {}
                })
            }
        },
        fileUrl(file) {
            if (!file) {
                return ''
            }
            if (file.length > 4) {
                if (file.substr(file.length - 4) === 'File') {
                    return (
                        this.userInfo[file.substr(0, file.length - 4)] ||
                        this.userInfo[file]
                    )
                }
            }
            return this.userInfo[file]
        }
    }
}
</script>
<style scoped>
#input2 {
    background-color: #ccc;
}
.avatar-uploader,
.el-upload,
.avatar {
    width: 178px;
    height: 178px;
}
</style>



// WEBPACK FOOTER //
// src/views/Amend.vue